// src/components/Navbar.jsx
import React from "react";
import { Box, Button, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

const tabs = [
  "Site Admin",
  "Unit Search",
  "Current Alarms",
  "Notifications",
  "Home View",
  "Area Status",
  "Reports",
];

export default function Navbar({
  activeTab,
  setActiveTab,
  onLogout,
  onMenuClick,
}) {
  const tabsContainerRef = React.useRef(null);

  // Handle mouse wheel for horizontal scrolling
  React.useEffect(() => {
    const container = tabsContainerRef.current;
    if (!container) return;

    const handleWheel = (e) => {
      // Only handle horizontal scroll if there's overflow
      if (container.scrollWidth > container.clientWidth) {
        e.preventDefault();
        container.scrollLeft += e.deltaY;
      }
    };

    container.addEventListener("wheel", handleWheel, { passive: false });
    return () => container.removeEventListener("wheel", handleWheel);
  }, []);

  return (
    <Box
      component="nav"
      sx={{
        backgroundColor: "#2c3e50",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          maxWidth: "100%",
          margin: "0 auto",
          padding: 0,
          gap: 0,
        }}
      >
        {/* Left: Menu + Tabs */}
        <Box
          ref={tabsContainerRef}
          sx={{
            display: "flex",
            alignItems: "center",
            flex: "1 1 auto",
            flexWrap: "nowrap",
            overflowX: "auto",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
            minWidth: 0,
            mr: 0,
            pr: 0,
            marginRight:"20px",
            scrollBehavior: "smooth",
          }}
        >
          <IconButton
            color="inherit"
            edge="start"
            onClick={onMenuClick}
            sx={{
              ml: 0.5,
              mr: 1,
              display: { md: "none" }, // Hide on medium & large
              color: "#ecf0f1",
              padding: "4px",
              flexShrink: 0,
              height: { xs: "45px", sm: "auto" },

            }}
          >
            <MenuIcon sx={{ fontSize: "20px" }} />
          </IconButton>

          {tabs.map((tab) => (
            <Button
              key={tab}
              onClick={() => setActiveTab(tab)}
              sx={{
                background: "none",
                border: "none",
                color: activeTab === tab ? "#ffffffff" : "#ecf0f1",
                // 📱 SMALL (xs): Compact padding
                // 📱 MEDIUM (sm): Medium padding
                // 💻 LARGE (md): Full padding
                padding: {
                  xs: "6px 6px", // Small screen
                  sm: "10px 15px", // Medium screen
                  md: "15px 30px", // Large screen
                },
                // 📱 SMALL: 9px
                // 📱 MEDIUM: 13px
                // 💻 LARGE: 16px
                fontSize: {
                  xs: "11px", // Small screen
                  sm: "13px", // Medium screen
                  md: "16px", // Large screen
                },
                fontWeight: 700,
                borderBottom: "3px solid",
                borderBottomColor:
                  activeTab === tab ? "#ffffffff" : "transparent",
                borderRadius: 0,
                textTransform: "none",
                transition: "all 0.3s ease",
                flexShrink: 0,
                whiteSpace: "nowrap",
                "&:hover": {
                  backgroundColor: "#34495e",
                  color: "#ffffffff",
                },
                "&.MuiButton-root": {
                  minWidth: "unset",
                },
              }}
            >
              {tab}
            </Button>
          ))}
        </Box>

        {/* Right: Logout */}
        <Box
          sx={{
            pr: {
              xs: 0.5, // Small screen
              sm: 1, // Medium screen
              md: 2, // Large screen
            },
            pl: 0,
            flexShrink: 0,
            flexGrow: 0,
          }}
        >
          <Button
            variant="contained"
            color="error"
            onClick={onLogout}
            sx={{
              textTransform: "none",
              fontWeight: "bold",
              borderRadius: "8px",

              px: {
                xs: 1, // Small screen
                sm: 1.5, // Medium screen
                md: 3, // Large screen
              },
              py: {
                xs: 0.4, // Small screen
                sm: 0.6, // Medium screen
                md: 1, // Large screen
              },

              fontSize: {
                xs: "11px", // Small screen
                sm: "13px", // Medium screen
                md: "16px", // Large screen
              },

              minWidth: {
                xs: "55px", // Small screen
                sm: "70px", // Medium screen
                md: "auto", // Large screen
              },
            }}
          >
            Logout
          </Button>
        </Box>
      </Box>
    </Box>
  );
}